import { Link, router, usePage } from '@inertiajs/react'
import type { ReactNode } from 'react'
import Layout from '../../layouts/Layout'

interface Post {
  id: string
  title: string
  large: string
  thumbnail: string
  link: string
  username: string
  userId: string
}

interface PageProps {
  currentUser?: {
    id: string
  }
  [key: string]: unknown
}

interface Props {
  post: Post
}

export default function Show({ post }: Props) {
  const { currentUser } = usePage<PageProps>().props

  const handleDelete = () => {
    if (window.confirm('Are you sure you want to delete this post?')) {
      router.delete(`/posts/${post.id}`)
    }
  }

  const isOwner = currentUser?.id === post.userId

  return (
    <Layout title={post.title || `Photo by @${post.username}`}>
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        {/* Image */}
        <div className="mb-6">
          <img
            src={post.large}
            alt={post.title || 'Post image'}
            className="w-full rounded-lg shadow-lg"
          />
        </div>

        {/* Post Info */}
        <div className="space-y-4">
          {post.title && (
            <h1 className="text-2xl font-semibold">{post.title}</h1>
          )}

          <div className="flex items-center justify-between">
            <Link
              href={`/${post.username}`}
              className="text-lg text-gray-600 hover:text-black"
            >
              @{post.username}
            </Link>

            <div className="flex items-center space-x-4">
              <a
                href={post.link}
                className="text-sm text-gray-500 hover:text-gray-700"
              >
                Permalink
              </a>

              {isOwner && (
                <>
                  <Link
                    href={`/posts/${post.id}/edit`}
                    className="text-sm text-gray-500 hover:text-gray-700"
                  >
                    Edit
                  </Link>
                  <button
                    onClick={handleDelete}
                    className="text-sm text-red-500 hover:text-red-700"
                  >
                    Delete
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

Show.layout = (page: ReactNode) => page
